import logUtil from 'utils/log'
import { PRODUCTS_KEY } from 'modules/product/redux/constants'
import loadFromUrlProductAction from 'modules/product/redux/actions/load-from-url'
import getCurrentDataSidebarSelect from 'modules/sidebar/redux/selectors/get-current-data'
import loadByIdDeepAndUpdateCurrentProductVariantAction from 'modules/product-variant/redux/actions/load-by-id-deep-and-update-current'

/**
 * @param productVariant
 * @param variantIdFromUrl
 * @param productIdFromUrl
 * @param isFullSize
 * @param isSample
 * @returns {(function(*, *): Promise<void>)|*}
 */
const loadAndUpdateProductAndVariantIdFromUrlQuickShopAction = ({
  productVariant,
  variantIdFromUrl,
  productIdFromUrl,
  isFullSize,
  isSample
}) => {
  return async (dispatch, getState) => {
    /**
     * @type {QuickShopSidebarData}
     */
    const sidebarData = getCurrentDataSidebarSelect(getState())

    logUtil('loadAndUpdateProductAndVariantIdFromUrlQuickShopAction').debug('[start]')
    if (productVariant) {
      logUtil('loadAndUpdateProductAndVariantIdFromUrlQuickShopAction').debug('[noop] already have productVariant')
      return
    }

    const debugProps = {
      variantIdFromUrl,
      productIdFromUrl
    }
    logUtil('loadAndUpdateProductAndVariantIdFromUrlQuickShopAction').debug('debugProps=', debugProps)

    if (!productIdFromUrl) {
      logUtil('loadAndUpdateProductAndVariantIdFromUrlQuickShopAction').debug('[noop] no product_id')
      return
    }

    if (!variantIdFromUrl) {
      logUtil('loadAndUpdateProductAndVariantIdFromUrlQuickShopAction').debug('[noop] no variant_id')
      return
    }

    // This logic should be used in other places
    const resData = await dispatch(loadByIdDeepAndUpdateCurrentProductVariantAction(variantIdFromUrl))
    if (isFullSize) {
      logUtil('loadAndUpdateProductAndVariantIdFromUrlQuickShopAction').debug('load full size')
      return
    }

    const propsToPass = {
      key: PRODUCTS_KEY.PRODUCTS_FROM_URL,
      isFullSize,
      isGiftSetSlider: sidebarData?.isGiftSetSlider,
      isSample,
      isJustDroppedSlider: !!sidebarData?.isJustDroppedSlider,
      sampleTabSelected: isSample,
      endpoint: sidebarData?.endpoint,
      query: {
        product_ids: [productIdFromUrl],
        variant_ids: [variantIdFromUrl]
      }
    }

    logUtil('loadAndUpdateProductAndVariantIdFromUrlQuickShopAction').debug('propsToPass=', propsToPass)
    await dispatch(loadFromUrlProductAction(propsToPass))

    logUtil('loadAndUpdateProductAndVariantIdFromUrlQuickShopAction').debug('[done] resData=', resData)
  }
}

export default loadAndUpdateProductAndVariantIdFromUrlQuickShopAction
